<template>
  <div>
    <div class="row">
      <div class="col-12">
        <card class="card-gis-filter">
          <el-collapse v-model="activeName" @change="handleCollapse">
            <el-collapse-item :title="titleFilter" name="1">
              <div class="row mt-3">
                <div class="col-12 col-sm-4 col-md-4">
                  <label for="">{{ $t('common_words.farm') }}: </label>
                  <br />
                  <el-select
                    @change="selectAllFromSelect('farmSel', farms)"
                    multiple
                    collapse-tags
                    clearable
                    style="width: 100%"
                    filterable
                    class="select-primary mb-3 shadow-sm"
                    v-model="farmSel"
                    :placeholder="`${$t('common_words.select2')}...`"
                  >
                    <el-option
                      class="select-primary selected-all"
                      v-for="item in farms"
                      :key="item.id + item.name"
                      :label="item.name"
                      :value="item.id"
                    >
                    </el-option>
                  </el-select>
                </div>
                <div class="col-2">
                  <div class="text-left">
                    <label style="color: white">button</label>
                    <br />
                    <button
                      class="btn btn-filter btn-wd btn-info custom-shadow-btn"
                      @click="handleFilterRange"
                    >
                      {{ $t('common_words.filter') }}
                    </button>
                  </div>
                </div>
              </div>
            </el-collapse-item>
          </el-collapse>
        </card>
        <div class="row" v-if="details">
          <div class="col-12 map-climate">
            <div
              ref="map"
              class="map"
              v-if="renderComponent"
              style="height: 800px"
            ></div>
            <div
              id="toolbarDiv"
              class="esri-component esri-widget"
              v-if="renderComponent"
            >
              <button
                id="distance"
                class="action-button esri-widget--button esri-interactive esri-icon-measure-line"
                style="margin-bottom: 10px"
                :title="$t('common_words.distance_measurement_tool')"
              ></button>
              <button
                id="area"
                class="action-button esri-widget--button esri-interactive esri-icon-measure-area"
                style="margin-bottom: 10px"
                :title="$t('common_words.area_measurement_tool')"
              ></button>
              <button
                id="clear"
                class="action-button esri-widget--button esri-interactive esri-icon-trash"
                style="margin-bottom: 10px"
                :title="$t('common_words.clear_measurement')"
              ></button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinArcgisMap from 'src/util/mixinArcgisMap';
import mixinMasters from 'src/util/mixinMasters';
import MixinMenu from 'src/util/mixinMenu';
import MixinForm from 'src/mixins/forms/mixin-form';

export default {
  computed: {
    titleFilter() {
      if (this.valueCollapse) {
        return this.valueCollapse.length === 1
          ? this.$i18n.t('uti.mixinFilter.hideFilters')
          : this.$i18n.t('uti.mixinFilter.showFilters');
      }

      return this.$i18n.t('uti.mixinFilter.hideFilters');
    },
  },

  data() {
    return {
      center: {
        lat: 37.774546,
        lng: -122.433523,
      },
      activeName: '1',
      farms: [],
      farmSel: [],
      valueCollapse: null,
      mapData: {},
      map: null,
      renderComponent: true,
      details: false,
    };
  },

  mixins: [
    MixinPermissions,
    MixinArcgisMap,
    mixinMasters,
    MixinForm,
    MixinMenu,
  ],

  watch: {
    '$i18n.locale': 'getSelectAll',
  },

  methods: {
    getSelectAll() {
      this.farms = this.concatAll(this.farms.splice(1));
    },
    handleFilterRange() {
      this.details = false;
      this.loadMap();
    },

    handleCollapse(val) {
      this.valueCollapse = val;
    },

    geolocate: function () {
      navigator.geolocation.getCurrentPosition((position) => {
        this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        };
      });
    },

    loadMap() {
      this.renderComponent = false;
      this.details = true;
      this.showHideLoading(true);
      let namesFiles = [];
      let centers = [];

      for (let index = 0; index < this.farms.length; index++) {
        if (
          this.farms[index].id != 0 &&
          this.farmSel.includes(this.farms[index].id)
        ) {
          this.center = {
            lat: this.farms[index].latitude,
            lng: this.farms[index].longitude,
          };

          centers.push(this.center);

          if (
            this.farms[index].other_values &&
            JSON.parse(this.farms[index].other_values).files
          ) {
            JSON.parse(this.farms[index].other_values).files.forEach(
              (element) => {
                namesFiles.push(
                  this.farms[index].id +
                    '/' +
                    element +
                    '|' +
                    this.farms[index].name
                );
              }
            );
          }
        }
      }

      this.$nextTick(() => {
        this.renderComponent = true;
        this.details = true;
        this.loadMapMultipleC(namesFiles, true, false, centers);
        this.showHideLoading();

        setTimeout(() => {
          document.getElementById('toolbarDiv').style = 'top: 13%;right: 30px;';
        }, 10);
      });
    },
  },

  created() {
    this.showHideLoading(true);
    Axios.getMasters('farms/farms/only')
      .then((response) => {
        this.farms = this.concatAll(response.data.data);

        if (this.farms.length > 0) {
          if (this.farms[0].id != 0) {
            this.farmSel.push(this.farms[0].id);
          }
        }

        // this.loadMap();

        this.showHideLoading();
      })
      .catch((error) => {
        this.showHideLoading();
      });
  },

  mounted() {
    this.selectedItemOnMenu('gis');
  },

  destroyed() {
    this.deselectedItemOnMenu('gis');
  },
};
</script>
<style lang="scss">
.card-gis-filter .card-body {
  padding: 15px 15px 10px 15px !important;
}

.card-gis-filter > .el-popper[x-placement^='bottom'] {
  margin-top: 38px !important;
}

.card-gis-filter div.el-collapse-item__header {
  padding-left: 10px !important;
}

.card-gis-filter {
  margin-bottom: 0px !important;
}
</style>
